import { createAction, props } from '@ngrx/store';

export const RequestAuthToken = createAction('[Root] Request Auth Token');

export const SetAuthToken = createAction(
  '[Root] Set Auth Token',
  props<{ authToken: string; userType?: string }>()
);

export const ClearAuthToken = createAction('[Root] Clear Auth Token');
